export default "__VITE_ASSET__DFxL4x9R__"